module.exports = __webpack_public_path__ + "static/img/newTenant.a69a17b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/system/assets/newTenant.png
// module id = jlWg
// module chunks = 3 8